import { ReactNode, useState } from 'react';
import { useClipboard } from '../../hooks/use-clipboard';
import { classNames } from '../../helpers/classNames';

interface Props {
  text: string;
  children: ReactNode;
  position?: 'left' | 'right';
  iconColor?: string;
}

export const CopyIconButton = ({ children, position = 'right', text, iconColor = 'text-gray-400' }: Props) => {
  const [copied, setCopied] = useState(false);
  const { copy } = useClipboard();
  const copiedClassNames = copied ? 'text-green-500' : iconColor;

  const copyHandler = () => {
    copy(text, () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 200);
    });
  };

  return (
    <div className="inline-flex items-center">
      {position === 'left' && (
        <span onClick={copyHandler}>
          <i className={classNames('fas fa-copy mr-psc-sm cursor-pointer', copiedClassNames)} />
        </span>
      )}
      {children}
      {position === 'right' && (
        <span onClick={copyHandler}>
          <i className={classNames('fas fa-copy ml-psc-sm cursor-pointer', copiedClassNames)} />
        </span>
      )}
    </div>
  );
};
